/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Suggestion_UnpaidInputs */

const en_admin_ai_chat_suggestion_unpaid = /** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which members have unpaid invoices?`)
};

const de_admin_ai_chat_suggestion_unpaid = /** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Mitglieder haben offene Rechnungen?`)
};

const es_admin_ai_chat_suggestion_unpaid = /** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué miembros tienen facturas pendientes?`)
};

const fr_admin_ai_chat_suggestion_unpaid = /** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels membres ont des factures impayées ?`)
};

const nl_admin_ai_chat_suggestion_unpaid = /** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke leden hebben openstaande facturen?`)
};

/** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */
const it_admin_ai_chat_suggestion_unpaid = en_admin_ai_chat_suggestion_unpaid;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_suggestion_unpaid = en_admin_ai_chat_suggestion_unpaid;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */
const pl_admin_ai_chat_suggestion_unpaid = en_admin_ai_chat_suggestion_unpaid;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */
const hu_admin_ai_chat_suggestion_unpaid = en_admin_ai_chat_suggestion_unpaid;

/** @type {(inputs: Admin_Ai_Chat_Suggestion_UnpaidInputs) => LocalizedString} */
const ro_admin_ai_chat_suggestion_unpaid = en_admin_ai_chat_suggestion_unpaid;

/**
* | output |
* | --- |
* | "Which members have unpaid invoices?" |
*
* @param {Admin_Ai_Chat_Suggestion_UnpaidInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_suggestion_unpaid = /** @type {((inputs?: Admin_Ai_Chat_Suggestion_UnpaidInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Suggestion_UnpaidInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "de") return de_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "es") return es_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "fr") return fr_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "nl") return nl_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "it") return it_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "pl") return pl_admin_ai_chat_suggestion_unpaid(inputs)
	if (locale === "hu") return hu_admin_ai_chat_suggestion_unpaid(inputs)
	return ro_admin_ai_chat_suggestion_unpaid(inputs)
});
export { admin_ai_chat_suggestion_unpaid as "admin.ai_chat.suggestion_unpaid" }